<template>
  <div class="page page-single">
    <HeaderSlide />
    <div class="page-container">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/security' }">資訊安全政策</el-breadcrumb-item>
      </el-breadcrumb>
      <article>
        <div class="page-title">
          資訊安全政策 <a accesskey="C" href="#content" title="content" class="accesskey-content" >:::</a>
        </div>
        <section>
          <h2>壹、目的</h2>
          <p>
            行政院農業委員會林務局及所屬機關肩負維護森林生態、保育自然資源之使命，為了達到下列之營運與管理目標，訂定本政策。<br>
            一、核心業務之資訊化作業得以持續不間斷運作，維持內部制度管理之有效性，提升對社會公眾之資訊服務品質。<br>
            二、確保所蒐集、處理與利用之所有資訊的機密性、完整性與正確性。<br>
            三、有關蒐集、處理與利用之個人資訊業務流程，符合「個人資料保護法」的要求<br>
          </p>
          <h2>貳、適用範圍</h2>
          <p>
            一、管理制度<br>
            本政策適用於資訊安全管理制度與個人資訊保護制度。<br>
            二、組織單位<br>
            (一)資訊安全管理制度本局各組（室）與各所屬機關之全體人員、業務往來單位、委外服務廠商、訪客及使用本局資訊服務之使用者等。<br>
            (二)個人資訊保護制度本局各組（室）與各所屬機關之人員所負責或經辦之業務或業務往來單位、委外服務廠商接受本局委託涉及蒐集、處理與利用個人資訊者。<br>
          </p>
          <h2>參、政策要求</h2>
          <p>
            一、落實相關法令之遵循，包括智慧財產權保護法、個人資料保護法、行政院及所屬各機關資訊安全管理要點與規範等相關法規及與外部單位簽訂之協議、契約。<br>
            二、本局成立資訊安全管理委員會、各所屬機關成立資訊推動及安全處理小組，積極推動管理制度相關事項之計畫、執行、稽核、持續改善與溝通協調，並積極辦理資訊安全與個人資料保護之教育訓練及宣導，以確保人員熟悉業務執行所負之安全責任。<br>
            三、員工業務持有之資訊資產以公有公用為原則，依需求規劃進行分類分級，並進行業務需求考量之風險評估，達到有效之控管；資訊系統應予分級並實施資安防護基準；資訊化作業依業務執行之實際需求，規劃營運持續管理，以確保資訊化作業之可用性。<br>
            四、實體辦公環境及重要資訊設備機房均進行出入管制，並持續監控以維持環境之安全。<br>
            五、資訊設備及系統以採行強化之技術防護管理為原則，以職務劃分及最小需求之原則進行存取權限管理，以防止系統遭受不當存取、異動、損害或網路攻擊。<br>
            六、為防範電腦病毒及惡意軟體影響作業，除經合法授權之系統及應用軟體外，禁止使用其他非授權軟體。<br>
            七、對於個人資訊保護，必須符合下列要求：<br>
            (一)個人資訊之蒐集、處理與利用，應有特定目的，且為本局執行法定職務必要範圍，或經當事人同意，確保資訊取得之合法、正確及合適性。<br>
            (二)委託第三方組織蒐集、處理與利用個人資訊，必須進行管理與保護。<br>
            (三)提供當事人對其個人資訊查詢、製作複本、修正、補充、刪除或停止利用與抱怨或申訴之程序與管道，並於發生個人資訊安全事件時主動告知。<br>
            (四)指定專人辦理個人資料保護事項，對個人資訊之蒐集、處理與提供利用，應採取適當保護措施，防止個人資料被竊取、竄改、毀損、滅失或洩漏。<br>
            八、為確保管理制度之有效性，凡違反管理制度相關程序規範者，依相關規定審議懲處。<br>
          </p>
          <h2>肆、責任</h2>
          <p>
            一、本局成立管理組織統籌管理制度相關事項之推動。<br>
            二、管理階層應積極參與及支持管理制度，並透過適當的標準和程序以實施本政策。<br>
            三、本局全體人員、委外服務廠商與訪客等皆應遵守本政策。<br>
            四、本局全體人員及委外服務廠商均有責任透過適當通報機制，通報資訊安全事件或弱點。<br>
            五、任何危及資訊安全與個人資訊保護之行為，將視情節輕重追究其民事、刑事及行政責任或依本局之相關規定進行議處。<br>
          </p>
          <h2>伍、實施與修正</h2>
          <p>
            本政策經資訊安全管理委員會審查通過，由局長核定後實施，修正時亦同。<br>
          </p>
        </section>        
      </article>
    </div>
  </div>
</template>

<script>
  import HeaderSlide from '@/components/frontstage/HeaderSlide.vue';
  import api from '@/api/frontstage'

  import {
    Hooper,
    Slide,
    Navigation as HooperNavigation,
    Pagination as HooperPagination
  } from 'hooper';
  import 'hooper/dist/hooper.css';
  export default {
    name: 'news',
    components: {
      HeaderSlide,
      Hooper,
      Slide,
      HooperNavigation,
      HooperPagination
    },
    async created () {
        if (typeof this.$route.params === 'undefined' || typeof this.$route.params.id === 'undefined') {
          return
        }

        let res = await api.get_latest_news(this.$route.params.id)
        if (res.success) {
            console.log('[前臺] news: ', res)
            this.news = res['payload']['payload']
        }
        else {
            this.notify_message(this.ERROR.LEVEL.ERROR, '無法取得文章', res.message)
            return
        }
    },
    data() {
      return {
        APP: process.env.VUE_APP_URL,
        hooperAttachImageSettings: {
          autoPlay: false,
          playSpeed: 5000,
          transition: 1000,
          infiniteScroll: false,
          wheelControl: false,
          itemsToShow: 3,
          itemsToSlide: 3,
        },
        news: {}
      }
    }
  }
</script>

<style>
  .accesskey-content{
    color: white;
  }
</style>